export default "__VITE_ASSET__BUUMTRb4__"